var searched = false;

$(function()
{
	$(el('edtPages')).on('keyup',function(e){
		var code = (e.keyCode ? e.keyCode : e.which);
		if(code == 13 && $(this).val() !== '') {
		    searchContent($(this).val());
		}
	});

	$(el('searchPages')).on('click',function(){
		if($(el('edtPages')).val() !== '' || searched) {
		    searchContent($(el('edtPages')).val(),inspirationDefaultCount);
		}
	});

	$(el('inspiration')).on('click', '.tagBlock', function()
	{
		var tagKeyword   = "";
		var tagSortBy    = "";
		var tagFilterTag = undefined;

		if($(this).hasClass('recentTags'))
		{
			tagSortBy = "recent";
		}
		else if($(this).hasClass('popularTags'))
		{
			tagSortBy = "views";
		}
		else
		{
			tagFilterTag = $(this).find('.label').text();
		}

		$(el('edtPages')).val(tagFilterTag);
		searchContent(tagKeyword,inspirationDefaultCount,tagSortBy,tagFilterTag);
	});

	$(el('pages')).on('click','.btnLoadMore',function(){
		searchContent($(el('edtPages')).val(),$(this).data('count'), $(this).data('sortBy'));
	});

	$(el('inspiration')).on('click','.deleteDefaultTag',function()
	{
		var sTagId = $(this).parents('.tagBlock').data('id');
		askRemoveDefaultTag(sTagId);
	});

	$(el('popupContinue')).on('click', '#deleteDefaultTag', function() {
		deleteDefaultTag($(this).attr('tagid'));
	});

	$(el('inspiration')).on('click', '#createDefaultTag', function() {
		var sTag = $(el('inputTag')).val();

		if(sTag !== '')
		{
			createDefaultTag(sTag);
		}
	});

	$(el('inspiration')).on('click','.editDefaultTag',function()
	{
		var sTagId = $(this).parents('.tagBlock').data('id');
		askEditDefaultTag(sTagId);
	});

	$(el('popupContinue')).on('click', '#editDefaultTag', function() {
		editDefaultTag($(this).attr('tagid'));
	});

	// Hover content item
	$(el('pages')).on({
	    mouseenter: function () {
			var color = $(this).find('.banner').data('color');
			if(color !== '')
			{
				$(this).find('.banner').css('background',color);
			}
			else
			{
				$(this).find('.banner').css('background','#4d4d4d');
			}
	    },
	    mouseleave: function () {
			$(this).find('.banner').css('background','#fff');
	    }
	}, ".item");

	//IE and edge fallback for object fit css property
	if(!Modernizr.objectfit)
	{
		//inspiration
		if($(el('pages')).length)
		{
			$('#pages .item').each(function () {
				objectFitFallback($(this));
			});
		}
	}
});

function askEditDefaultTag(sTagId)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'editDefaultTag', {'tagId': sTagId});
	setPopupHeader(oPopup, 'Edit tag', '')

	oTagFormHtml = $('.editTagForm').prop('outerHTML');
	oPopup.find('.modal-body .content').html(oTagFormHtml);

	oPopup.find('.modal-body .control-label').html('Name:');
	oPopup.find('.modal-footer .action').html('Confirm');
	oPopup.find('.modal-footer .cancel').html('Cancel');

	oPopup.modal();
}

function askRemoveDefaultTag(sTagId)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'deleteDefaultTag', {'tagId': sTagId});
	setPopupHeader(oPopup, 'Delete tag', '');
	oPopup.find('.modal-body .content').html('Are you sure you want to delete this tag?');

	oPopup.find('.modal-footer .action').html('Confirm');
	oPopup.find('.modal-footer .cancel').html('Cancel');

	oPopup.modal();
}

function createDefaultTag(sTag)
{
	var sParams = '&tag=' + encodeURIComponent(sTag);
	var oCall = callAjax("createDefaultTag", sParams, "post", "/index.cfm/content/ajax/createDefaultTag");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$('.defaultTagWrapper').html(oData.html);
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function editDefaultTag(sTagId)
{
	var oPopup       = $(el('popupContinue'));
	var oEditTagForm = oPopup.find('.editTagForm');
	var sParams      = getValues(oPopup, oEditTagForm, 'ajax');
	sParams += '&tagId=' + sTagId;

	var oCall = callAjax("editDefaultTag", sParams, "post", "/index.cfm/content/ajax/editDefaultTag");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$('.defaultTagWrapper').html(oData.html);
			$(el('popupContinue')).modal('hide');
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function deleteDefaultTag(sTagId)
{
	var sParams = '&tagId=' + sTagId;
	var oCall = callAjax("deleteDefaultTag", sParams, "post", "/index.cfm/content/ajax/deleteDefaultTag");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$('.defaultTagWrapper').html(oData.html);
			$(el('popupContinue')).modal('hide');
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function objectFitFallback(oElem)
{
	var imgUrl = oElem.find('img').prop('src');

	if(imgUrl)
	{
		oElem.css('backgroundImage', 'url("' + imgUrl + '")').addClass('compat-object-fit');
	}
}

function searchContent(keyword,count,sortBy,sFilterTag)
{
	if(keyword === '')
	{
		searched = false;
	}
	else
	{
		searched = true;
	}

	$('.loader').toggleClass('hidden').find('i').center();
	uAjax = "/index.cfm/content/ajax/searchcontent";
	var sParams = '&search=' + encodeURIComponent(keyword) + '&count=' + count;

	if(typeof sortBy !== 'undefined' && sortBy !== "")
	{
		sParams += '&sortBy=' + sortBy;
	}

	if(typeof sFilterTag !== 'undefined')
	{
		sParams += '&filterTags=' + encodeURIComponent(sFilterTag);
	}

	var oCall   = callAjax("searchcontent", sParams, "post");
	oCall.success(function(oData)
	{
		$('.loader').toggleClass('hidden');
		if(oData.errorType === '')
		{
			$(el('pages')).html(oData.html);
			$(el('pages')).find('.btnLoadMore').data('sortBy',sortBy);

			ciResponsive.process();
			// Scroll down
			if(count !== inspirationDefaultCount)
			{
				var nrElement = count - inspirationLoadmoreCount;
				if($(".item:eq(" + nrElement + ")").length > 0)
				{
				    $('html, body').animate({
				        scrollTop: $(".item:eq(" + nrElement + ")").offset().top - 100
				    }, 300);
				}
			}
		}
		else
		{
			showAlert('error', 'Problem finding content pages', false, 3000);
		}
	});
}